export default {
    namespaced: true,
    state: {
        //功能编码
        functions: [],
        //角色编码
        roles: [],
		roleIndexConfig: [],
        //接口
        interfaces: {
            GET: [],
            POST: [],
            PUT: [],
            DELETE: []
        },
		//用户所属店铺id（管理员=0）
		shopId: 0,
        //是否管理员
        isAdmin: false,
		//是否显示页面
		isShow: false,
    },
    mutations: {
        set(state, data) {
			console.log(data)
            state.functions = data.functions;
            state.roles = data.roles;
			state.roleIndexConfig = data.roleIndexConfig;
            state.interfaces = data.interfaces;
			state.shopId = data.shopId;
            state.isAdmin = data.isAdmin;
			state.isShow = true;
        }
    }
}